import { z } from 'zod';

export const countSchema = z.object({
  count: z.number(),
});

export const optionalDate = () =>
  z
    .union([z.number(), z.string()])
    .nullish()
    .transform((n) => (!n ? null : new Date(n)));
